// services/api/roleApi.js

import api from "./axios";

export const getRoles = async () => {
    const response = await api.get("/roles");

    console.log(
        "GET ROLES API:",
        response.data
    );

    return response.data;
};

export const getRole = (id) => api.get(`/roles/${id}`);

export const createRole = async (data) => {
  const response = await api.post("/roles", data);
  return response.data;
};

export const updateRole = async (id, data) => {
  const response = await api.patch(`/roles/${id}`, data);
  return response.data;
};

export const deleteRole = async (id) => {
  const response = await api.delete(`/roles/${id}`);
  return response.data;
};

export const assignPermissions = async (id, permissions) => {
  const response = await api.post(`/roles/${id}/permissions`, {
    permissions,
  });
  return response.data;
};